import { useState } from 'react';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function Login({ setUser }) {
  /* ЗАКОММЕНТИРОВАНО 2026-05-20: Форма email/пароль скрыта, все пользователи используют SSO
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/auth/login`, {
        email: formData.email,
        password: formData.password
      });
      localStorage.setItem('token', response.data.access_token);
      setUser(response.data.user);
      toast.success('Добро пожаловать!');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Неверный email или пароль');
    } finally {
      setLoading(false);
    }
  };
  */

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-orange-50 via-white to-orange-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900 px-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-24 h-24 mb-4">
            <img 
              src="https://customer-assets.emergentagent.com/job_expense-tracker-1156/artifacts/gtrb0n04_%D0%BB%D0%BE%D0%B3%D0%BE%20%D1%86%D0%B2%D0%B5%D1%82%D0%BE%D0%BA.png" 
              alt="Logo" 
              className="w-full h-full object-contain"
            />
          </div>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100 mb-2">Система согласования платежей</h1>
          <p className="text-gray-600 dark:text-gray-400">Управление платежами и счетами</p>
        </div>

        {/* Login/Register Form */}
        <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl p-8 border border-gray-100 dark:border-gray-700">
          <h2 className="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-6">
            Вход в систему
          </h2>

          {/* ЗАКОММЕНТИРОВАНО 2026-05-20: Форма email/пароль скрыта, все пользователи используют SSO
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label htmlFor="email" data-testid="email-label" className="text-gray-700 dark:text-gray-300">Email</Label>
              <Input
                id="email"
                type="email"
                data-testid="email-input"
                placeholder="email@company.com"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                required
                className="mt-1 text-gray-900 dark:text-gray-100 bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-600"
              />
            </div>

            <div>
              <Label htmlFor="password" data-testid="password-label" className="text-gray-700 dark:text-gray-300">Пароль</Label>
              <Input
                id="password"
                type="password"
                data-testid="password-input"
                placeholder="••••••••"
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                required
                className="mt-1 text-gray-900 dark:text-gray-100 bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-600"
              />
            </div>

            <Button
              type="submit"
              data-testid="submit-button"
              disabled={loading}
              className="w-full bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white font-medium py-3 rounded-xl shadow-md"
            >
              {loading ? 'Загрузка...' : 'Войти'}
            </Button>
          </form>

          <div className="relative my-6">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-gray-300 dark:border-gray-600"></div>
            </div>
            <div className="relative flex justify-center text-sm">
              <span className="px-2 bg-white dark:bg-gray-800 text-gray-500">или</span>
            </div>
          </div>
          */}

          <Button
            type="button"
            onClick={async () => {
              try {
                const response = await axios.get(`${API}/auth/oidc/login`);
                window.location.href = response.data.redirect_url;
              } catch (error) {
                toast.error('Ошибка перенаправления на SSO');
              }
            }}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 rounded-xl shadow-md"
          >
            🔐 Продолжить с IRISK ID
          </Button>
        </div>

        <div className="mt-6 text-center text-sm text-gray-500 dark:text-gray-400">
          Для входа используйте единую систему авторизации IRISK ID
        </div>
      </div>
    </div>
  );
}
